/**
 * Resource Local Forms JS
 *
 * @since 2.1.5
 */

(() => {

	/**
	 * Handle the registration state
	 * @param {HTMLElement} formContainer  The form container
	 */
	const handleRegistration = (formContainer) => {
		// Use querySelector to find the thank you text and the form container
		const thankYouText = formContainer.querySelector('.as-resources-form-thank-you');
		const form = formContainer.querySelector('.as-resources-form-alpha-wrapper');

		// Hide the form
		form.style.display = 'none';

		// Show the thank you text
		thankYouText.classList.remove('hidden');
		thankYouText.classList.add('flex');
	};


	/**
	 * Handle the form submit
	 */
	const handleFormSubmit = () => {
		// Get the form container
		const formContainer = document.getElementById('as-resources-form-container');

		// If the form container doesnt exist, lets leave
		if (!formContainer) {
			return;
		}

		// Get the webinar state if it exists
		const webinarState = formContainer.dataset.webinarState;

		// Seperate handling for registration state
		if (webinarState && webinarState === 'registration') {
			// We will display a message and not redirect
			handleRegistration(formContainer);
			return;
		}

		// If it is a resource/guide lets grab that
		if (webinarState && webinarState === 'report') {
			// Attempt to grab the data-gated-type
			const gatedType = formContainer.dataset.gatedType;

			// If it exists, lets handle it
			if (gatedType && gatedType === 'message') {
				// Lets grab the message container
				const messageContainer = document.getElementById('as-resources-form-gated-message');

				// If it exists, lets show it
				if (messageContainer) {
					messageContainer.classList.remove('hidden');
					messageContainer.classList.add('flex');

					// Hide the form
					formContainer.style.display = 'none';

					// Stop
					return;
				}
			}
		}

		// Get all the query params from the URL
		const urlParams = new URLSearchParams(window.location.search);

		// Append the completed=true to the URL
		urlParams.append("completed", "true");

		// Get the URL with all the query params to redirect to
		const redirectUrl = `${window.location.pathname}?${urlParams.toString()}`;

		// Redirect to the final URL
		window.location = redirectUrl;

	};


	/**
	 * Load the form
	 * @returns {void}
	 */
	const loadForm = () => {
		// Grab the form container
		const formContainer = document.getElementById('as-resources-form-alpha');

		// If it doesnt exist, lets GTFO
		if (!formContainer) {
			return;
		}

		// If it does, lets load in the HubSpot form
		const formId = formContainer.dataset.formId;
		const portalId = formContainer.dataset.portalId;
		const pageSlug = formContainer.dataset.pageSlug;

		// If any of these are missing
		if (!formId || !portalId || !pageSlug) {
			return;
		}

		// Now lets load the form
		hbspt.forms.create({
			portalId,
			formId,
			target: '#as-resources-form-alpha',
			onFormReady: () => {
				// Lets find the input with the name of 'page_slug'
				const pageSlugInput = formContainer.querySelector('input[name="page_slug"]');

				// If it exists, lets populate it with the current page slug
				if (pageSlugInput) {
					pageSlugInput.value = pageSlug;
				}
			},
			onFormSubmitted: () => {
				handleFormSubmit();
			}
		});
	};


	// Lets add an event listener to wait for the page to fully load
	document.addEventListener('DOMContentLoaded', function() {
		// Load the form
		loadForm();
	});
})();